export type PortalTheme = 'dark' | 'light'

export const DEFAULT_THEME: PortalTheme = 'dark'
export const THEME_STORAGE_KEY = 'cn-theme'
export const THEME_CHANGE_EVENT = 'cn-theme-change'

export function normalizeTheme(value: unknown): PortalTheme | null {
  return value === 'light' || value === 'dark' ? value : null
}

/** Aktywny motyw wynika wyłącznie z atrybutu data-theme na <html> (brak = dark). */
export function getActiveTheme(): PortalTheme {
  if (typeof document === 'undefined') {
    return DEFAULT_THEME
  }
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'
}

export function getStoredTheme(): PortalTheme | null {
  try {
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY))
  } catch {
    return null
  }
}

export function applyTheme(theme: PortalTheme): void {
  const root = document.documentElement
  // Zawsze jawna wartość (nie delete): usunięcie atrybutu potrafi zostawić
  // nieodświeżone style [data-theme='light'] na częściach drzewa (stale paint),
  // a zmiana wartości atrybutu inwaliduje style niezawodnie.
  root.dataset.theme = theme
  // Wymuszony synchroniczny reflow: Chromium potrafi zostawić fragmenty UI
  // przemalowane starym motywem (stale paint po masowej zmianie zmiennych CSS).
  void (document.body ?? root).offsetHeight
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme)
  } catch {
    // localStorage niedostępny (tryb prywatny) — motyw działa do końca sesji.
  }
  window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, { detail: { theme } }))
}
